var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporateSustainability47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-1{stroke:currentColor;}.cls-2{stroke:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "108.62 139.16 41.54 139.16 41.54 66.86 155.68 66.86 155.68 104.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.66,
    y: 88.02,
    width: 19.9,
    height: 10.85
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "75.4 66.48 75.4 53.55 121.82 53.55 121.82 66.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.78,
    y1: 93.12,
    x2: 155.68,
    y2: 93.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.54,
    y1: 93.12,
    x2: 78.45,
    y2: 93.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.67,
    y1: 185.25,
    x2: 185.06,
    y2: 106.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 153.92,
    y1: 162.2,
    x2: 133.33,
    y2: 155.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 142.88,
    y1: 117.92,
    x2: 148.32,
    y2: 138.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.15,
    y1: 138.58,
    x2: 156.28,
    y2: 133.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.25,170.84S79.66,97.35,186.5,105.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.76,172.46s70.88,40.56,70.35-66.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSustainability47);
export default __webpack_public_path__ + "static/media/CORPORATE_SUSTAINABILITY_47.a0f25ca03d6260205d6a02118546a76d.svg";
export { ForwardRef as ReactComponent };